const customRules = {
  pageName: 'Reglas personalizadas',
  btnCreate: 'Crear',
  form: {
    header: {
      create: {
        title: 'Reglas personalizadas',
      },
      update: {
        title: 'Reglas personalizadas',
      },
    },
    information: {
      details: {
        header: 'Detalles',
        fields: {
          name: 'Nombre',
          type: {
            name: 'Tipo',
            values: {
              tripPriority: 'Prioridad de viaje',
              driverPriority: 'Prioridad de conductor',
              passengerPreferences: 'Preferencias de pasajeros',
            },
          },
          passengerRuleType: {
            name: 'Tipo de regla',
            options: {
              passengers: 'Pasajeros',
              drivers: 'Conductores',
              vehicles: 'Vehículos',
              passengersAndDrivers: 'Pasajero y Conductores',
            },
          },
          source: {
            name: 'Fuente',
            values: {
              internal: 'Perfiles de pasajeros',
              integration: 'Reservas de invitados',
            },
          },
        },
      },
      preference: {
        header: 'Preferencias',
        fields: {
          passenger: 'Pasajero',
          passengers: 'Pasajeros',
          preferenceType: {
            name: 'Tipo de preferencia',
            values: {
              rideTogether: 'Viajar juntos',
              rideApart: 'Viajar separados',
              preferredDriver: 'Conductor preferido',
              excludedDriver: 'Conductor excluido',
              strictDriver: 'Conductor estricto',
              preferredVehicle: 'Vehículo preferido',
              excludedVehicle: 'Vehículo excluido',
            },
          },
          drivers: 'Conductores',
          driverPreferenceType: {
            name: 'Tipo de preferencia',
          },
          vehicleBy: {
            name: 'Vehículo por',
            values: {
              makeAndModel: 'Marca / modelo del vehículo',
              name: 'Nombre del vehículo',
            },
          },
          vehicleMake: 'Marca del vehículo',
          vehicleModels: 'Modelos de vehículo',
          vehicleNames: 'Nombres de vehículos',
          frequency: {
            name: 'Frecuencia',
            values: {
              always: 'Siempre',
              specificRange: 'Rango específico',
            },
          },
          dateFrom: 'Fecha desde',
          dateTo: 'Fecha hasta',
          timeFrom: 'Hora desde',
          timeTo: 'Hora hasta',
          weekdays: 'Días de la semana',
          direction: {
            name: 'Dirección',
            values: {
              both: 'Desde y hacia',
              pickup: 'Desde',
              dropoff: 'Hacia',
            },
            warningNoLocation: 'Si no se selecciona ninguna ubicación, elegir “Dirección: Desde/Hacia” separará automáticamente el Tramo A y el Tramo B.',
          },
          location: 'Ubicación',
          pickupOrder: {
            name: 'Establecer Orden de Recogida',
          },
        },
        actions: {
          add: '+ Agregar preferencia',
          addPassenger: 'Agregar',
        },
      },
      priority: {
        header: 'Registro {{count}}',
        recordHeader: 'Registro',
        scoreLabel: 'Puntuación',
        fields: {
          attributes: 'Atributos',
          areas: 'Zonas',
          profiles: 'Perfiles',
        },
        btnAddPriority: {
          label: '+ Agregar registro',
          tooltip: 'Agregar un nuevo nivel de registro',
        },
      },
    },
    footer: {
      btnSubmit: {
        create: 'Enviar',
        submitAndCreate: 'Enviar y crear',
        update: 'Enviar',
      },
    },
  },
  table: {
    headers: {
      name: 'Nombre',
      type: 'Tipo',
      priority: 'Prioridad',
      record: 'Registro',
      value: 'Valor',
      score: 'Puntuación',
      passengerRuleType: 'Tipo de regla',
    },
    filters: {
      recordType: 'Registro',
    },
    actions: {
      delete: {
        header: 'Eliminar',
        modal: {
          header: 'Eliminar reglas personalizadas',
          body: 'Está a punto de eliminar {{num}} reglas.',
        },
        toast: {
          success: 'Éxito!',
          error: 'Error!',
        },
      },
    },
    tabs: {
      tripsRules: 'Reglas de viajes',
      driversRules: 'Reglas de conductores',
      passengersRules: 'Preferencias de pasajeros',
    },
    toolTip: {
      noPermission: 'Acción no permitida: se requiere permiso',
    },
  },
  create: {
    toastSuccess: 'Éxito!',
    toastError: 'Fallo',
    toastValidationMessage: 'Por favor agregue atributos',
    errorConflict: {
      title: 'Conflicto de reglas de pasajeros',
      body: 'Hay un conflicto con la regla que intenta crear. Estos pasajeros ya están asignados a otra regla para el mismo rango de tiempo específico.',
    },
  },
  edit: {
    toastSuccess: 'Éxito!',
    toastError: 'Fallo',
    toastValidationMessage: 'Por favor agregue atributos',
    errorConflict: {
      title: 'Conflicto de reglas de pasajeros',
      body: 'Hay un conflicto con la regla que intenta actualizar. Estos pasajeros ya están asignados a otra regla para el mismo rango de tiempo específico.',
    },
  },
};

export default customRules;
